import styled from 'styled-components'

const MenuItemControlsUi = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 50px;
  align-items: center;
  justify-content: center;
`

export default MenuItemControlsUi
